module.exports = __webpack_public_path__ + "8b4715376b6fa6f3aac8b41fb2c3971f.svg";